<div class="advancedFilters__container">
  @if (ppFilters().length === 0) {
    <h6>{{ 'no_filters_applied_to_table' | ppTranslate }}</h6>
  }

  @for (filter of ppFilters(); let idx = $index; track idx) {
    <div class="advancedFilters__row-container">
      <pp-advanced-filters-row
        [ppFilter]="filter.item"
        [ppAdvancedFilter]="filter"
        [ppIndex]="idx"
        [ppLogic]="ppOperator()"
        (ppLogicChange)="ppOperatorChange.emit($event)"
        [ppWorkspaceId]="ppWorkspaceId()"
        (ppDeleteFilter)="deleteFilter(idx)"
        (ppFilterChange)="updateFilter(idx, $event)"
      />
    </div>
  }

  <button class="advancedFilters__new-filter-button" (click)="addNewFilter()">
    <pp-icon
      [ppSrc]="EIconPath.ICON_NAV_PLUS_14"
      ppColor="primary-950"
      [ppDisplayContents]="true"
    />
    <span>
      {{ 'add_filter_condition' | ppTranslate }}
    </span>
  </button>
</div>
